import React from "react"
import Router from "./Router"

import agent from './services/sportigo';
import { connect } from 'react-redux';
import { REDIRECT } from './redux/constants/main.constants';
import { Route, Switch, Redirect } from 'react-router-dom';
import { store } from './redux/storeConfig/store';
import { push } from 'react-router-redux';
import { loadCompany, loadUser } from './redux/actions/main.actions'
import PullToRefresh from 'react-simple-pull-to-refresh';


import Spinner from "./components/@vuexy/spinner/Fallback-spinner"
import Loader from './components/Loader';
import { Helmet } from 'react-helmet';

import "./components/@vuexy/rippleButton/RippleButton"

import "react-perfect-scrollbar/dist/css/styles.css"
import "prismjs/themes/prism-tomorrow.css"
import { history } from "./history";

const mapStateToProps = state => {
  return {
    appCompanyLoaded: state.main.appCompanyLoaded,
    appUserLoaded: state.main.appUserLoaded,
    appName: state.main.appName,
    company: state.main.company,
    config: state.main.config,
    member: state.main.member,
    inProgress: state.main.inProgress,
    redirectTo: state.main.redirectTo,
    login: state.main.login,
  }
};

const mapDispatchToProps = {
  loadCompany: loadCompany,
  loadUser: loadUser,
  noUser: () => ({ type: 'APP_NO_USER' }),
  publicPageInit: () => ({ type: 'PUBLIC_PAGE' })
};

class App extends React.Component {

  //componentWillReceiveProps(nextProps) {
  //  if (nextProps.redirectTo) {
  // this.context.router.replace(nextProps.redirectTo);
  //    store.dispatch(push(nextProps.redirectTo));
  //    store.dispatch({ type: REDIRECT });
  //  }
  //}

  componentWillMount() {
    this.props.loadCompany();
  }

  componentDidMount() {

    if (['/appointment', '/booking', '/giftcard'].includes(history.location.pathname)) {
      return this.props.publicPageInit();
    }

    setTimeout(() => {

      var newToken = window.localStorage.getItem('sportigo-user');
      if (newToken) {
        agent.setToken(newToken);
        this.props.loadUser();

        //if (history.location.pathname == '/appointment' || history.location.pathname == '/booking') {
        //  return this.props.publicPageInit();
        //}

      } else {

        //if (history.location.pathname == '/appointment' || history.location.pathname == '/booking') {
        //  return this.props.publicPageInit();
        //}

        this.props.noUser();
        history.push("/")
      }
    }, 1500);
  }

  isLogged() {
    return this.props.company && this.props.member
  }

  isLoaded() {
    return this.props.appCompanyLoaded && this.props.appUserLoaded;
  }

  handleRefresh = () => {
    return new Promise(res => {
      this.props.loadUser();
      //this.props.loadCompany();
      setTimeout(() => {
        res();
      }, 2000);
    });
    return this.props.loadUser();
  }

  render() {


    if (!this.isLoaded()) {
      return (
        <Spinner />
      );
    }

    return (
      <span>
        <Helmet>
          <style>
            {`
                            :root {
                                --primary-color: ${this.props.company.theme.primaryColor};
                                --secondary-color: ${this.props.company.theme.secondaryColor};
                            }`}
          </style>
        </Helmet>

        {this.props.config.enable ? (
          //this.isLogged() ? this.renderConnected() : this.renderNotConnected()
          <PullToRefresh onRefresh={() => this.handleRefresh()}>
            <Router />
          </PullToRefresh>
        ) : (
          <div>
            <h1 className="text-center">Oops ...</h1>
          </div>
        )}
      </span>
    )
  }
}

// App.contextTypes = {
//   router: PropTypes.object.isRequired
// };

export default connect(mapStateToProps, mapDispatchToProps)(App);